export default {
  namespaced:true,
  state:{
    nodes:[],
    menus:[]
  },
  mutations:{
    setToken(state, token) {
      state.nodes = token
    },
  },
  getters:{

  },
  actions:{
    login({commit}, {token}) {
      commit('setToken',token)
    }
  }
}